// extracted by mini-css-extract-plugin
export default {"closeDetailsButton":"CloseDetailsButton_closeDetailsButton__HeL30"};